module.exports = __webpack_public_path__ + "img/egg_stars_sad.79f9630a.svg";